var e=!0;function n(){return e}function o(t){e=t;}

export { n as a, o as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4JXGMDWW.mjs.map